import angular from 'angular';

angular.module('cxInvoicing').directive('cxInvoiceTypeahead', [
  'invoicingSvc',
  '$filter',
  function(invoicingSvc, $filter) {
    return {
      restrict: 'E',
      replace: true,
      require: 'ngModel',
      scope: {
        ngModel: '=',
        customerId: '<?',
      },
      template: `
        <div class="dropdown" uib-dropdown is-open="ddwOpen">
          <div class="input-group">
            <input type="text"
                   ng-model="searchText"
                   uib-typeahead="item as formatInvoiceLabel(item) for item in searchInvoices($viewValue)"
                   typeahead-template-url="invoiceTypeaheadTemplate.html"
                   ng-model-options="{updateOn: 'default blur', debounce: { 'default': 400, 'blur': 0 }}"
                   typeahead-min-length="0"
                   typeahead-select-on-blur="false"
                   typeahead-select-on-exact="true"
                   typeahead-on-select="onSelect($item)"
                   ng-blur="onBlur()"
                   class="form-control"
                   placeholder="{{'Search invoices' | translate}}"
                   autocomplete="off"/>
          </div>
        </div>
      `,
      link: function($scope, el, attrs, ngModel) {
        $scope.formatInvoiceLabel = function(item) {
          if (!item) return null;
          const relationName = $filter('relationName')(item.customer);
          const currency = $filter('dynCurrency')(item.amount);
          const date = $filter('formatDate')(item.date);
          return `${item.number}: ${relationName} - ${currency} [${date}]`;
        };

        $scope.searchInvoices = function(query) {
          if (!query) {
            return invoicingSvc
              .retrieveUnpaidInvoices(50, { ownCompanies: [$scope.customerId] })
              .then(result => result || []);
          }
          return invoicingSvc.searchUnpaidInvoices(query).then(result => result || []);
        };

        $scope.onSelect = function(item) {
          ngModel.$setViewValue(item);
          $scope.ngModel = item;
        };

        $scope.onBlur = function() {
          if (!$scope.ngModel) {
            ngModel.$setViewValue(null);
          }
        };

        ngModel.$render = function() {
          $scope.ngModel = ngModel.$viewValue;
          $scope.searchText = $scope.ngModel ? $scope.formatInvoiceLabel($scope.ngModel) : '';
        };
      },
    };
  },
]);

angular.module('cxInvoicing').run([
  '$templateCache',
  function($templateCache) {
    $templateCache.put(
      'invoiceTypeaheadTemplate.html',
      `
      <a href>
        <div>
            <span>{{match.model.number}} - </span>
            <cx-relation-handling-level
              handling-level="match.model.customer.relationHandlingLevel"
              clarification="match.model.customer.relationHandlingLevelClarification">
            </cx-relation-handling-level>
            <span class="bold">{{match.model.customer | relationName}} - </span>
            <span>{{match.model.amount | dynCurrency}} [{{match.model.date | formatDate}}] </span>
        </div>
      </a>
    `,
    );
  },
]);
